import { render, staticRenderFns } from "./ResultPlate.vue?vue&type=template&id=50b87656&scoped=true&"
import script from "./ResultPlate.vue?vue&type=script&lang=js&"
export * from "./ResultPlate.vue?vue&type=script&lang=js&"
import style0 from "./ResultPlate.vue?vue&type=style&index=0&id=50b87656&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b87656",
  null
  
)

export default component.exports